import(/* webpackMode: "eager" */ "/my-new-one/app/global-error.tsx")